import { render, staticRenderFns } from "./MatchInfoHeader.vue?vue&type=template&id=d824e436&scoped=true&"
import script from "./MatchInfoHeader.vue?vue&type=script&lang=js&"
export * from "./MatchInfoHeader.vue?vue&type=script&lang=js&"
import style0 from "./MatchInfoHeader.vue?vue&type=style&index=0&id=d824e436&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d824e436",
  null
  
)

export default component.exports